/**
 * Standalone / new flights module: real LDS BOOK is enforced only on the backend.
 * Default: proposal-only rows until env LDS_FLIGHTS_ENABLE_REAL_BOOK=true (see lds_flights_module_proposal_guard.py).
 * Send on createLdsNewOrder / saveDynamicPackage flights payload as a top-level field.
 */
export const FLIGHTS_MODULE_PROPOSAL_ONLY_BODY_KEY = "flights_module_proposal_only";

/** Top-level saveDynamicPackage: flight-only proposal, no hotel order (backend bookDynamicPackage). */
export const FLIGHTS_NEW_SOURCE_MODULE = "flights_new";

export function withFlightsModuleProposalOnly(flightsPayload) {
  if (!flightsPayload || typeof flightsPayload !== "object") return flightsPayload;
  return { ...flightsPayload, [FLIGHTS_MODULE_PROPOSAL_ONLY_BODY_KEY]: true };
}

/** Marks saveDynamicPackage body as flights_new first-class flow (requires flight_only: true). */
export function withFlightsNewSavePayload(body) {
  if (!body || typeof body !== "object") return body;
  return {
    ...body,
    source_module: FLIGHTS_NEW_SOURCE_MODULE,
    flight_only: true,
  };
}
